module.exports = __webpack_public_path__ + "img/basket.d071bc53.svg";